import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import ButtonModule from '../../libs/component-lib/components/button/button-module';
import CardModule from '../../libs/component-lib/components/card/card.module';
import CurrencyModule from '../../libs/component-lib/components/currency/currency.module';
import MediaObjectModule from '../../libs/component-lib/components/media-object/media-object.module';
import { PriceListModule } from '../../libs/component-lib/components/price-list/price-list.module';
import { SmoothHeightModule } from '../../libs/component-lib/components/smooth-height/smooth-height.module';
import { ChargingCardModule } from '../../libs/feature-lib/charging-card/charging-card.module';
import { ChargingStationModule } from '../../libs/feature-lib/charging-station/charging-station.module';
import { EvsbProductOverviewComponent } from './evsb-product-overview.component';
import { EvsbProductOverviewMapper } from './evsb-product-overview.mapper';
import { EvsbProductOverviewService } from './evsb-product-overview.service';

@NgModule({
  declarations: [EvsbProductOverviewComponent],
  exports: [EvsbProductOverviewComponent],
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    CardModule,
    ButtonModule,
    SmoothHeightModule,
    CurrencyModule,
    PriceListModule,
    MediaObjectModule,
    ChargingCardModule,
    ChargingStationModule,
  ],
  providers: [EvsbProductOverviewMapper, EvsbProductOverviewService],
})
export class EvsbProductOverviewModule {}
